export const INTERFACE_KITS = {
  donor: {
    button: {
      primary: 'solid-primary',
      secondary: 'outline-primary',
      tertiary: 'solid-light',
      danger: 'outline-danger'
    },
    input: 'outline',
    table: 'zebra',
    typography: 'poppins',
    rounded: true,
  },
  naung: {
    button: {
      primary: 'solid-primary',
      secondary: 'solid-grey',
      tertiary: 'text',
      danger: 'outline-danger'
    },
    input: 'outline',
    table: 'zebra',
    typography: 'archivo',
    rounded: true,
  },
  derma: {
    button: {
      primary: 'solid-primary',
      secondary: 'outline-grey',
      tertiary: 'text',
      danger: 'outline-danger'
    },
    input: 'outline',
    table: 'outline',
    typography: 'roboto',
    rounded: true,
  },
  cagar: {
    button: {
      primary: 'solid-primary',
      secondary: 'outline-grey',
      tertiary: 'text',
      danger: 'outline-danger'
    },
    input: 'outline',
    table: 'outline',
    typography: 'source',
    rounded: false,
  },
  altruis: {
    button: {
      primary: 'solid-primary',
      secondary: 'outline-secondary',
      tertiary: 'text',
      danger: 'outline-danger'
    },
    input: 'solid',
    table: 'outline',
    typography: 'lato',
    rounded: false,
  },
}
export const INTERFACE_KIT = INTERFACE_KITS['donor']
export const COLOR_THEMES = [
  'forest',
  'pacific',
  'glacier',
  'atlantis',
  'butter',
  'sunkist',
  'amaranth',
]
